import React, { useRef, useEffect } from "react";

const RichTextEditorComponent = ({
  handleChange,
  initialValue = "",
  style = {},
}) => {
  const editorRef = useRef(null);

  useEffect(() => {
    // Initialize editor only once on component mount
    if (window.RichTextEditor) {
      editorRef.current = new window.RichTextEditor("#div_editor1");
      editorRef.current.setHTMLCode(initialValue); // Set initial content
      editorRef.current.attachEvent("change", handleEditorChange);
    } else {
      console.error("RichTextEditor is not loaded");
    }

    // Cleanup editor when the component unmounts or when the initialValue changes
    return () => {
      if (editorRef.current) {
        editorRef.current.detachEvent("change", handleEditorChange);
        editorRef.current = null;
      }
    };
  }, []); // This useEffect only runs once to initialize the editor

  useEffect(() => {
    // Whenever `initialValue` changes (when question is reset), update editor content
    if (editorRef.current) {
      if (initialValue) {
        editorRef.current.setHTMLCode(initialValue);
      } // Reset the editor content
    }
  }, [initialValue]); // Dependency on `initialValue`

  function handleEditorChange() {
    if (editorRef.current) {
      const htmlCode = editorRef.current.getHTMLCode();
      handleChange(htmlCode); // Notify parent component about the change
    }
  }

  return (
    <div>
      <div id="div_editor1" style={style}></div>
    </div>
  );
};

export default RichTextEditorComponent;
